import React from 'react';
import { ShieldPRDForBrowser } from 'App/ShieldPRD/ShieldPRDForBrowser';
import { ShieldPRDForChromeApp } from 'App/ShieldPRD/ShieldPRDForChromeApp';
import { isCitrixChromeApp, isDesktopBrowser } from 'Environment/launchResource/device';

export const ShieldPRD: React.FC = () => {
	return (
		<>
			{isCitrixChromeApp() && <ShieldPRDForChromeApp />}
			{isDesktopBrowser() && <ShieldPRDForBrowser />}
		</>
	);
};
